import http from '../../../utils/services/http'

export const getTiposParte = () => {
  let url = `/api/processos/all-tiposParte`
  return http.get(url)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export const listPartes = (limit, page, filtros) => {
  let url = `/api/processos/partes?page=${page}&limit=${limit}${filtros}`
  return http.get(url)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
}
